import { AxiosInstance } from 'axios';
import { TransportationCarrierEnum } from '@/compiler/transportation';
import baseAxios from '@/helpers/forms/axios';

export interface carrierInterface {
    carrier: TransportationCarrierEnum
}

export default (axios: AxiosInstance = baseAxios): { fetchCarriers: () => Promise<carrierInterface[]>; } => ({
    fetchCarriers: async (): Promise<carrierInterface[]> => {
        const response = await axios.get<carrierInterface[]>('/api/staff/settings/carriers');

        return response.data;
    },
});
